import { IncludedKeywordCategory } from '../interfaces/searchCondition';
import { QUERY_PARAMS } from './queryParams';

export const SCREEN_NAMES = {
  keyword: 'keywordScreen',
  occupation: 'occupationScreen',
  location: 'locationScreen',
  area: 'areaScreen',
  city: 'cityScreen',
  station: 'stationScreen',
  other: 'otherScreen',
  otherTop: 'otherScreenTop',
  otherMenu: 'otherScreenMenu',
  industry: 'industryScreen',
  workingStyles: 'workingStylesScreen',
} as const;

export type SearchConditionsModalType =
  (typeof SCREEN_NAMES)[keyof typeof SCREEN_NAMES];

export const SCREEN_TITLES = {
  keyword: 'キーワードから探す',
  occupation: '職種から探す',
  location: '勤務地から探す',
  area: '都道府県から探す',
  city: '市区郡から探す',
  station: '路線・駅から探す',
  other: '詳細条件から探す',
  industry: '業種の設定',
  workingStyles: '休日・働き方の設定',
  locationTypeOther: '勤務地を絞り込む',
  occupationTypeOther: '職種の設定',
  occupationDrilledDown: '職種を絞り込む',
  industryDrilledDown: '業種を絞り込む',
};

export const BUTTON_TEXTS = {
  occupation: '職種を',
  location: '勤務地を',
  other: '詳細条件を',
  normal: 'この条件で',
};

export const TEMPLATE_CONDITION = {
  so: '50',
  ss: '1',
  pic: '1',
  ds: '0',
  bf: '0',
};

export const TEMPLATE_PARAM = {
  ...TEMPLATE_CONDITION,
  bf: '1',
  mpsc_sid: 10,
  oldestDayWdtno: 0,
};

export const LOCATION_TITLES_SEPARATER = '、';

export const PATH_SEPARATER = '/';
export const OTHER_TITLES_SEPARATER = '／';

// 設定可能な検索条件
export const SELECTABLE_CONDITION = [
  QUERY_PARAMS.ar, // 勤務地地域
  QUERY_PARAMS.pr, // 勤務地都道府県
  QUERY_PARAMS.ci, // 市区町村団体コード
  QUERY_PARAMS.wa, // 政令指定都市団体コード
  QUERY_PARAMS.rt, // 路線コード
  QUERY_PARAMS.st, // 駅コード
  QUERY_PARAMS.oc, // 職種
  QUERY_PARAMS.ind, // 業種
  QUERY_PARAMS.k, // キーワード(～含む)
  QUERY_PARAMS.op, // その他
  QUERY_PARAMS.ha, // 年収
  QUERY_PARAMS.ne, // 従業員数
  QUERY_PARAMS.es, // 設立
  QUERY_PARAMS.tp, // 求人種別
];

// 検索条件数上限
export const SEARCH_CONDITION_LIMIT = 60;

export const RANGE_LIST: {
  label: string;
  value: IncludedKeywordCategory;
}[] = [
  {
    label: 'すべて',
    value: '1',
  },
  {
    label: '社名',
    value: '2',
  },
  {
    label: '職種',
    value: '3',
  },
  {
    label: '勤務地',
    value: '4',
  },
  {
    label: '経験・スキル',
    value: '9',
  },
];
